import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './venue-search-result.css'

const VenueSearchResult = ({ handleSelect, name, address1, address2, postalCode }) => (
  <div styleName="result" onClick={handleSelect}>
    <div styleName="name">{name}</div>
    <div styleName="address">{address1}, {address2 && address2}, {postalCode}</div>
  </div>
)

VenueSearchResult.propTypes = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  handleSelect: PropTypes.func,
  name: PropTypes.string,
  postalCode: PropTypes.string,
}

export default CSSModules(VenueSearchResult, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/venue-search/venue-search-results/venue-search-result.js
 **/